import fetch from 'cross-fetch';

import { createBaseApi, getAuthHeaders } from '../utils/baseApi';

const apiVersion = 'v1';

const { getJson, postJson, deleteJson, putJson } = createBaseApi(`/api/${apiVersion}`, { headers: getAuthHeaders });

export const getProcoreOauthCallback = (pinsCompanyId, procoreCompanyId, code) => getJson('/procore/oauth/callback', { pins_company_id: pinsCompanyId, procore_company_id: procoreCompanyId, code });

export const getProcoreProjectDetails = (pinsAccessToken, companyId, procoreProjectId) => {
  const { getJson: customGet } = createBaseApi(`/api/${apiVersion}`, { headers: { Authorization: `Bearer ${pinsAccessToken}` } });

  return customGet(`/companies/${companyId}/procore-projects/${procoreProjectId}`);
};

export const getProcoreProjectRecordsExcel = (pinsAccessToken, companyId, procoreProjectId, filters) => {
  const { getJson: customGet } = createBaseApi(`/api/${apiVersion}`, { headers: { Authorization: `Bearer ${pinsAccessToken}` } });

  return customGet(`/companies/${companyId}/procore-projects/${procoreProjectId}/records/reports`, filters);
};

export const getProcoreProjectRecords = (
  pinsAccessToken,
  companyId,
  procoreProjectId,
  pageOptions,
  filters
) => {
  const { getJson: customGet } = createBaseApi(`/api/${apiVersion}`, { headers: { Authorization: `Bearer ${pinsAccessToken}` } });

  return customGet(`/companies/${companyId}/procore-projects/${procoreProjectId}/records`, pageOptions, filters);
};

/* PROCORE INTEGRATION API
========================================================= */

const getProcoreIntegrationUrl = () => {
  const local = PROCORE_INTEGRATION_LOCAL_URL;
  let sub = null;

  switch (PINS_ENV) {
    case 'prod':
      sub = 'procore';
      break;
    case 'qa':
      sub = 'procore-qa';
      break;
    case 'dev':
      sub = 'procore-dev';
      break;
    default:
      break;
  }

  return sub ? `https://${sub}.pinsadvantage.com` : local;
};

export const getCompanyIdFromProcoreCompanyId = procoreCompanyId => {
  const procoreIntegrationUrl = getProcoreIntegrationUrl();

  return fetch(`${procoreIntegrationUrl}/api/integration-clients/${procoreCompanyId}/pins-companies`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json; text/plain; text/xml'
    }
  }).then(response => {
    if (response.status === 403) {
      console.log('Unauthorized request to fetch pins company id using procore company id');
    }

    return response.json();
  });
};

